module.exports = __webpack_public_path__ + "static/media/download_qr_code_czy.d2ddd15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/download_qr_code_czy.png
// module id = 425
// module chunks = 0